var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditReview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.75C0 0.335786 0.335786 0 0.75 0H9C9.41421 0 9.75 0.335786 9.75 0.75C9.75 1.16421 9.41421 1.5 9 1.5H1.5V13.5H4C4.25076 13.5 4.48494 13.6253 4.62404 13.834L6 15.8979L7.37596 13.834C7.51506 13.6253 7.74924 13.5 8 13.5H16.5V8.68182C16.5 8.2676 16.8358 7.93182 17.25 7.93182C17.6642 7.93182 18 8.2676 18 8.68182V14.25C18 14.6642 17.6642 15 17.25 15H8.40139L6.62404 17.666C6.48494 17.8747 6.25076 18 6 18C5.74924 18 5.51506 17.8747 5.37596 17.666L3.59861 15H0.75C0.335786 15 0 14.6642 0 14.25V0.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8697 0.219661C14.1626 -0.0732321 14.6375 -0.0732321 14.9304 0.219661L17.7588 3.04809C17.8994 3.18874 17.9785 3.37951 17.9785 3.57842C17.9785 3.77733 17.8994 3.9681 17.7588 4.10875L11.5664 10.3011C11.4257 10.4418 11.235 10.5208 11.0361 10.5208L8.20764 10.5208C8.00872 10.5208 7.81796 10.4418 7.67731 10.3011C7.53665 10.1605 7.45764 9.96972 7.45764 9.77081L7.45764 6.94238C7.45764 6.74347 7.53665 6.5527 7.67731 6.41205L13.8697 0.219661ZM14.4 1.81065L8.95764 7.25304V9.02081L10.7254 9.02081L16.1678 3.57842L14.4 1.81065Z",
    fill: "currentColor",
    className: "accent"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditReview);
export default __webpack_public_path__ + "static/media/edit-review.d14b14b1ba072ddfd0ed02edb2fe18ef.svg";
export { ForwardRef as ReactComponent };